'use client'

import FollowUpScrubber from './FollowUpScrubber'

// Dental: the two revenue leaks the page names, hygiene recalls and
// unaccepted treatment plans, each as an automated sequence on a day slider.
// Touch days follow the page's own recall plan (email, SMS day 7, voice day
// 14, front desk day 21) and its $4,200 treatment-plan example.

const SCENARIOS = {
  recall: {
    tab: 'Hygiene recall',
    person: { initials: 'ML', name: 'Maria Lopez', detail: 'Last cleaning May 3 · due for her 6-month visit', status: 'Due for cleaning' },
    startDay: 0,
    maxDay: 21,
    dayLabel: (d) => (d === 0 ? 'Recall day' : `Day ${d}`),
    idle: "Waiting for Maria's recall date…",
    touches: [
      { day: 0, channel: 'email', label: 'Recall email', message: "Hi Maria, it's time for your cleaning. Pick a date that suits you." },
      { day: 7, channel: 'sms', label: 'Text reminder', message: "Hi Maria, your 6-month cleaning is due. Reply with a day that works and we'll hold a spot." },
      { day: 14, channel: 'voice', label: 'Voicemail drop', message: 'A friendly recorded reminder from the front desk.' },
      { day: 21, channel: 'call', label: 'Front desk call', message: 'Task for the front desk: call Maria personally.' },
    ],
    reply: { day: 8, text: 'Tuesday morning works, thanks!', status: 'Booked: Tue 9:30 AM', stamp: 'Recall booked · day 8' },
  },
  plan: {
    tab: 'Treatment plan',
    person: { initials: 'DK', name: 'David Kim', detail: 'Treatment plan presented: crown + implant, $4,200', status: 'Plan not accepted' },
    startDay: 0,
    maxDay: 14,
    dayLabel: (d) => (d === 0 ? 'Visit day' : `Day ${d}`),
    idle: 'David left without scheduling the treatment…',
    touches: [
      { day: 1, channel: 'sms', label: 'Check-in text', message: 'Hi David, any questions about the treatment plan Dr. Patel went through? Happy to help.' },
      { day: 3, channel: 'email', label: 'Financing options', message: 'How the $4,200 can be spread into monthly payments, plus what your insurance covers.' },
      { day: 7, channel: 'call', label: 'Coordinator call', message: 'Task for the treatment coordinator: call David.' },
      { day: 14, channel: 'sms', label: 'Last reminder', message: 'Your quoted price is held until the end of the month.' },
    ],
    reply: { day: 8, text: "The monthly option works. Let's schedule it.", status: 'Accepted: $4,200', stamp: 'Plan accepted · $4,200' },
  },
}

export default function DentalRecall() {
  return (
    <FollowUpScrubber
      title="Recalls and plans, followed up for you"
      label="Demo: an automated hygiene recall and treatment-plan follow-up for a dental practice"
      scenarios={SCENARIOS}
    />
  )
}
